import React from 'react';
import Nauvari from './asset/nauvari2.png'; 
import onepiece from './asset/onepiece.png'; 
import Ghagra from './asset/ghagra2.png'; 
import Blouse from './asset/blouse.png';
import saree from './asset/saree.png';
import stiching from './asset/stiching.png';
import lacha22 from './asset/lacha22.png';

const services = [
  {
    id: '01',
    name: 'Shahi Nauvari Stitching',
    tag: 'Signature Service',
    description:
'Bespoke Nauvari stitching featuring traditional Maharashtrian patterns, handcrafted pleats, elegant silhouettes, and personalized fitting for weddings, festivals, and cultural events.',
    image: Nauvari,
    size: 'lg:col-span-2 lg:row-span-2' 
  },
{
  id: '02',
  name: 'Handmade One-Piece',
  tag: 'Bespoke Fashion',
  description:
    'Individually handcrafted one-piece dresses with personalized styling, luxurious fabrics, and contemporary designs tailored to complement your unique personality.',
  image: onepiece,
  size: 'lg:col-span-1 lg:row-span-1'
},
 {
  id: '03',
  name: 'Designer Lacha Couture',
  tag: 'Royal Elegance',
  description:
    'Handcrafted designer lachas tailored with premium fabrics, custom patterns, and elegant silhouettes, creating a timeless look for weddings and festive celebrations.',
  image: lacha22,
  size: 'lg:col-span-1 lg:row-span-1'
},
  {
  id: '04',
  name: 'Custom Blouse Design & Stitching',
  tag: 'Artisan Crafted',
  description:
    'Choose from hundreds of exclusive blouse patterns with customized sleeves, neck designs, premium fabrics, and handcrafted finishes to create your perfect look.',
  image: Blouse,
  size: 'lg:col-span-1 lg:row-span-2'
},
 {
  id: '05',
  name: 'Ready-to-Wear Sarees',
  tag: 'Effortless Elegance',
  description:
    'Beautifully pre-stitched sarees crafted with premium fabrics, customizable draping styles, and designer finishes for effortless elegance on every occasion.',
  image: saree,
  size: 'lg:col-span-1 lg:row-span-1'
},
{
  id: '06',
  name: 'Designer Ghagra Couture',
  tag: 'Royal Tradition',
  description:
    'Handcrafted ghagras tailored with premium fabrics, personalized designs, and traditional silhouettes, customized to reflect your unique style for weddings and festive celebrations.',
  image: Ghagra,
  size: 'lg:col-span-1 lg:row-span-1'
},
 {
  id: '07',
  name: 'Designer Custom Tailoring',
  tag: 'Your Style, Our Craft',
  description:
    'Transform your ideas into reality with custom stitching for any fabric, featuring personalized designs, flawless tailoring, and handcrafted detailing for every occasion.',
  image: stiching,
  size: 'lg:col-span-1 lg:row-span-1'
},
  {
    id: '08',
    name: 'Festive Ready-Made Collections',
    tag: 'Gifting & Festive',
    description: 'Curated premium one-pieces and traditional silhouettes perfect for Gauri-Ganpati, Diwali, and festive celebrations.',
    image: onepiece,
    size: 'lg:col-span-1 lg:row-span-1'
  }
];

const ServicesCollection = () => {
  return (
    <section className="bg-[#FAF8F5] py-24 px-4 md:px-12 lg:px-20">
      <div className="max-w-7xl mx-auto">
        
        {/* Header Section */}
        <div className="text-center max-w-3xl mx-auto mb-16 space-y-4">
          <span className="text-[11px] font-medium uppercase tracking-widest text-[#5c1d24] bg-[#5c1d24]/5 px-4 py-1.5 rounded-full">
            परंपरा आणि आधुनिकता • Heritage & Style
          </span>
          <h2 className="font-serif text-3xl md:text-5xl text-[#2D221E] tracking-wide font-normal">
            Our Atelier Services
          </h2>
          <div className="w-16 h-[2px] bg-[#A97C50] mx-auto mt-4"></div>
          <p className="text-xs md:text-sm text-neutral-600 font-light max-w-xl mx-auto pt-2 leading-relaxed">
            Celebrating the rich legacy of Marathi textile traditions through bespoke customization, handloom curation, and master craftsmanship.
          </p>
        </div>

        {/* Crisp Traditional-Modern Mosaic Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 auto-rows-[280px]">
          {services.map((service) => (
            <div
              key={service.id}
              className={`group relative overflow-hidden bg-white border border-[#5c1d24]/10 p-2 transition-all duration-500 hover:border-[#A97C50] flex flex-col justify-end ${service.size}`}
            >
              {/* Image Container - Full Vibrancy & Zoom */}
              <div className="absolute inset-2 overflow-hidden bg-neutral-100">
                <img
                  src={service.image}
                  alt={service.name}
                  className="w-full h-full object-cover object-center transition-transform duration-700 ease-out group-hover:scale-105"
                />
                {/* Micro-thin gradient just at the bottom to guarantee readable typography */}
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/10 to-transparent opacity-80 group-hover:opacity-90 transition-opacity duration-300"></div>
              </div>

              {/* Minimalist Fine-Line Tag */}
              <div className="absolute top-5 left-5 z-10">
                <span className="bg-[#5c1d24] text-white text-[9px] font-semibold tracking-widest uppercase px-2.5 py-1 shadow-sm">
                  {service.tag}
                </span>
              </div>

              {/* Elevated Info Box */}
              <div className="relative z-10 p-4 w-full bg-black/30 backdrop-blur-xs border-t border-white/10 transform translate-y-2 transition-transform duration-300 group-hover:translate-y-0">
                
                <div className="flex items-start space-x-2">
                  <span className="font-serif text-[#A97C50] text-xs font-bold pt-0.5">
                    {service.id}
                  </span>
                  <h3 className="font-serif text-base text-white tracking-wide font-medium leading-tight drop-shadow-xs">
                    {service.name}
                  </h3>
                </div>

                {/* Smooth Slide-in Details */}
                <div className="grid grid-rows-[0fr] opacity-0 group-hover:grid-rows-[1fr] group-hover:opacity-100 group-hover:mt-2 transition-all duration-300 ease-in-out">
                  <div className="overflow-hidden">
                    <p className="text-[11px] text-neutral-200 font-light leading-relaxed mb-2">
                      {service.description}
                    </p>
                    
                  </div>
                </div>

              </div>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default ServicesCollection;